import { ApolloClient, from, InMemoryCache } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

const _instance = {}

const createApolloClient = (initialState = {}, cookie = null) => {
  const isServer = typeof window === 'undefined'
  const browserCacheKey = '__browser__'

  if (!isServer && _instance[browserCacheKey]) return _instance[browserCacheKey]
  if (isServer && cookie && _instance[cookie]) return _instance[cookie]

  const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          //define a custom merge function to update chatAiThreads array after deleting a thread to avoid "Cache data may be lost" warning (https://medium.com/@dexiouz/fix-cache-data-may-be-lost-when-replacing-the-getallposts-field-of-a-query-object-in-apollo-client-7973a87a1b43)
          chatAiThreads: {
            merge(_existing, incoming) {
              return incoming
            }
          }
        }
      }
    }
  }).restore(initialState)

  const client = new ApolloClient({
    ssrMode: true,
    link: from([
      createUploadLink({
        uri: process.env.GRAPHQL_URL || 'https://app.worshiponline.com/graphql',
        credentials: 'include',
        headers: { cookie }
      })
    ]),
    connectToDevTools: true,
    resolvers: {},
    cache
  })

  if (!isServer) {
    _instance[browserCacheKey] = client
  } else if (cookie) {
    _instance[cookie] = client
  }

  return client
}

export const staticPath = ({
  additionalPaths = async (_) => {
    return {}
  }
}) => {
  return async (ctx) => {
    const client = createApolloClient({})

    return {
      ...(await additionalPaths({ client, ctx }))
    }
  }
}

export const staticProps = ({
  additionalProps = async (_) => {
    return {}
  }
}) => {
  return async (ctx) => {
    const client = createApolloClient({})

    return {
      props: {
        ...(await additionalProps({ client, ctx }))
      },
      revalidate: 3600
    }
  }
}

export default createApolloClient
